var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmotionalIntelligence(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.49 59.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #805aed;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.79,58.75H8.47v-18.12C3.73,36.43.75,30.38.75,23.66.75,11,11.27.75,24.24.75s23.47,10.25,23.47,22.91c0,.87-.05,1.74-.15,2.6-.05.43.03.86.24,1.23l4.71,8.26c.57.98,0,2.21-1.1,2.45l-4.84,1v7.84c0,1.35-1.1,2.45-2.47,2.45h-10.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.52,45.09l1.68,1.67c1.74,1.74,4.11,2.72,6.58,2.72"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "35.8 49.48 35.8 58.75 32.64 58.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.3,19.11c0,5.1-3.99,7.58-6.85,7.46-.72-.03-.53-.02-.92-.04-1.01,2.53-4.74,3.83-7.88,3.06-.02.7-.49,2.05-3.95,1.98-4.66-.09-6.4,5.53-6.4,5.53h-3.18s1.84-3.16,1.38-5.06c-.45-1.91-1.7-.88-4.12-1.57-2.25-.65-1.75-3.15-1.67-3.49-1.89-.84-2.91-2.96-2.67-6.02.08-.92.38-1.88.85-2.73.47-.84,1.1-1.58,1.8-2.05-.29-1.18.03-3.17,1.95-5.18,2.47-2.57,4.96-2.12,5.77-1.85,1.14-1.3,3.22-2.91,6.6-3.22,2.06-.17,4.1.57,5.43,1.54,2.49-.75,6.1.27,8.07,2.97.75,1.03.9,2.28.83,3.33,1.93-.03,4.92,1.46,4.92,5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.24,24.93c-9.03-3.95-7.38-10.28-3.79-11,2.58-.52,3.79,1.48,3.79,1.48,0,0,1.21-2,3.79-1.48,3.59.72,5.24,7.06-3.79,11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotionalIntelligence);
export default __webpack_public_path__ + "static/media/emotional-intelligence.645a9a63c67448dd07c9cc7da2e75b74.svg";
export { ForwardRef as ReactComponent };